import React, { useContext, useEffect, useMemo, useRef, useState } from 'react'
import ReportContent from '@comp/tableDrawer/reportContent'
import ReportHeader from '@comp/tableDrawer/reportHeader'
import { AcceptProvider, GetAllProvider, RejectProvider } from '../../../../../api/endpoints'
import { useUpdate } from '@/api/hooks'
import { useNavigate } from 'react-router-dom'
import { DomainContext } from '@context/DomainContext'
import { PROVIDER_REQUEST_STATUS } from '@/data/status'
import ReportSearch from '@comp/tableDrawer/reportSearch'
import ActionBtn from '@/components/ActionBtn'
import { CRRender } from '@/components/crRender'
import TextPopup from '@/components/popups/TextPopup'
import BaseBtn from '@/components/tableDrawer/TableItems/components/tableActions/BaseBtn'

const AllRequests = ({ columns, TabsSection }) => {

    const openInsertModal = useRef()
    const { setCustomSearchData } = useContext(DomainContext)

    const [rejectId, setRejectId] = useState(null)
    const rejectModal = useRef()
    const { onUpdate: onAccept } = useUpdate(AcceptProvider)
    const { onUpdate: onReject } = useUpdate(RejectProvider)

    const navigate = useNavigate()

    const tableColumns = useMemo(() => [...columns
        ,
    {
        Header: 'details',
        Cell: ({ row: { original } }) => {
            return (
                <>
                    <BaseBtn action={"show-details"} onApply={() => navigate(`/panel/request-details/${original?.id}`)} icon={"solar:eye-outline"} className="details-info" reqAction="canAdd" />
                </>
            )
        }
    }
        ,
    {
        id: 'action',
        Cell: ({ row: { original } }) => {
            return (
                <>
                    <CRRender isRender={original?.statusId == PROVIDER_REQUEST_STATUS?.Pending}>
                        <ActionBtn onApply={() => onAccept(original?.id)} title="accept" className="accept-btn" reqAction="canAdd" icon={"si:check-fill"} />
                        <ActionBtn onApply={() => handleReject(original?.id)} title="reject" className="reject-btn" reqAction="canAdd" icon={"codex:cross"} />
                    </CRRender>
                </>
            )
        },
    },
    ], [])


    const handleReject = (id) => {
        rejectModal.current.click()
        setRejectId(id)
    }

    const rejectAction = (text) => {
        onReject(rejectId, { note: text })
        rejectModal.current.click()
    }



    useEffect(() => {
        setCustomSearchData(prev => ({ ...prev, statusId: "" }))
    }, [])

    return (
        <>
            <TextPopup textRef={rejectModal} onApply={rejectAction} />
            <ReportContent tableAPI={GetAllProvider} columns={tableColumns}>
                <ReportHeader ApplyAction={openInsertModal} >
                    <ReportSearch />
                </ReportHeader>
                <TabsSection />

            </ReportContent>
        </>
    )
}

export default AllRequests